import { Injector } from "@angular/core";
import { ResultList } from "../../ListEntity/ResultList";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";
import { BaseNode } from "../../BaseNode";
import { EntityEnum } from "../../EntityEnum";
import { PaginationControl } from "../../../PaginationControl";
import { WebTraderQueryResultNode } from "../WebTraderQueryResultNode";
import { DateUtil } from "../../../DateUtil";
import { testingEnum } from "../../../../common/enum/testingEnum";
import { Art57NodeUtils } from "../../Art57Node/Art57NodeUtils";
import { FromEudravigilanceListView } from "../../../Data/WebTraderData/FromEudravigilanceListView";
import { QueryNodeFromEudravigilance } from "../Query/QueryNodeFromEudravigilance";
import { QueryConditionNodeFromEudravigilance } from "../Query/QueryConditionNodeFromEudravigilance";

export class ResultListNodeFromEudravigilance extends ResultList {

    constructor (injector: Injector) {
        super(injector);
    }

    override addResult(requestedNode: BaseNode, itemPagination: PaginationControl,data: any, parentNode: BaseNode): BaseNode|null{
        const listViewData = new FromEudravigilanceListView(data);
        let resultNodeFromEudravigilance = null;
        const selectedNode = requestedNode; 
        if ( selectedNode instanceof QueryNodeFromEudravigilance || selectedNode instanceof WebTraderQueryResultNode) {
            selectedNode.data = listViewData;
        } else {
            const conditionsNode = Art57NodeUtils.findChildNodeOfType(this.parent!.children as BaseNode[],QueryConditionNodeFromEudravigilance) as QueryConditionNodeFromEudravigilance;
            resultNodeFromEudravigilance = new WebTraderQueryResultNode(this.ioc!,listViewData,"Result " + DateUtil.getResultDateTime(), EntityEnum.fromEV,null,conditionsNode, []);
            resultNodeFromEudravigilance.paginationControl = itemPagination;
            if (data.length == 0) {
              this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'warn', id:testingEnum.noResultsFoundToastMsg, detail: 'No result(s) found for the specified condition(s)', life: environment.warningElapsedTime });
            }  
        
            if (!(this.ioc!.get(Art57Section).getSelectedSection().selectedNode instanceof QueryNodeFromEudravigilance)) {
                resultNodeFromEudravigilance.parent = parentNode;
                this.children?.push(resultNodeFromEudravigilance);
            } else {
                resultNodeFromEudravigilance.parent = requestedNode;
            }    
        }

        return resultNodeFromEudravigilance;
    }
}